import '@fontsource/barlow/400.css';
import '@fontsource/barlow/500.css';
import '@fontsource/barlow/600.css';
import '@fontsource/barlow-condensed/700.css';
import '@fontsource/noto-sans-devanagari/400.css';
import '@fontsource/noto-sans-devanagari/600.css';
import '@fontsource/noto-sans-devanagari/700.css';
import './styles.css';

import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { I18nextProvider } from 'react-i18next';
import { createBrowserRouter, RouterProvider } from 'react-router';

import { createI18n } from './i18n';
import { DEFAULT_LOCALE, localeFromPath } from './i18n/config';
import { routes } from './routes';

const container = document.getElementById('root');
if (container === null) throw new Error('#root element is missing');

// Messages for the URL's locale are loaded before the first render, so hydration matches.
const i18n = await createI18n(localeFromPath(window.location.pathname) ?? DEFAULT_LOCALE);
const router = createBrowserRouter(routes);

const app = (
  <StrictMode>
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <RouterProvider router={router} />
      </I18nextProvider>
    </HelmetProvider>
  </StrictMode>
);

// Prerendered public pages come with markup to hydrate; app.html (dashboard, admin) is empty.
if (container.firstElementChild !== null) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
